import type { ReactNode } from "react"

import AppLayoutTemplate from "@/layouts/app/app-header-layout"
import type { BreadcrumbItem } from "@/types"

interface AppLayoutProps {
  children: ReactNode
  breadcrumbs?: BreadcrumbItem[]
}

export default function AppLayout({ children, ...props }: AppLayoutProps) {
  // Breadcrumbs are intentionally not rendered in this app; the prop is still
  // accepted so pages can keep passing it without changes.
  return <AppLayoutTemplate {...props}>{children}</AppLayoutTemplate>
}
